'use strict';

module.exports = /*@ngInject*/
function(
    SuggestiveSearch
) {
    return {
        link: function(scope, element, attrs) {
            scope.$watch(function() {
                var snDelay;
                var snHeight;
                var snMoves;
                var scrollTop;
                var preventDefault;
                var closeSN;
                var activateSN;
                var delaySNOpen;
                var scrollHeader;

                SuggestiveSearch.suggestiveLocation();

                if (jQuery('.sn-container').length) {
                    snDelay = 80; // in ms
                    snHeight = jQuery('.sn-container').css('max-height').replace('px', '');
                    snMoves = 0;
                    scrollTop = 0;
                    preventDefault = function preventDefault(e) {
                        e.preventDefault();
                    };

                    closeSN = function closeSN() {
                        jQuery('.sn-container, .sn-container .sn-child-nav').removeClass('active');
                        jQuery('.global-nav a').removeClass('active');
                        jQuery('body').removeClass('topnav_visible');
                        jQuery('.below-header').css('top', '');
                    };

                    activateSN = function activateSN(e) {
                        var snClass = jQuery(e.currentTarget).attr('class').replace(' active', '');

                        if (!jQuery('.sn-container').hasClass('active')) {
                            jQuery('.below-header').css('top', '+=' + snHeight);
                        }

                        jQuery('.global-nav a').removeClass('active');
                        jQuery('body').addClass('topnav_visible');
                        jQuery('.sn-container .sn-child-nav').removeClass('active');
                        jQuery('.sn-container, .global-header .' + snClass).addClass('active');
                    };

                    // if user mouses off main nav link quicker than delay threshold, do not open sn
                    delaySNOpen = function delaySNOpen(e) {
                        var overTS = e.timeStamp;
                        var snDelayTimer = setTimeout(function() {
                                activateSN(e);
                            }, snDelay);

                        jQuery(this).on({
                            mouseout: function(e) {
                                var outTS = e.timeStamp;
                                if (outTS - overTS < snDelay) {
                                    clearTimeout(snDelayTimer);
                                }
                            }
                        });
                    };

                    scrollHeader = function scrollHeader() {
                            var speed = Math.abs(jQuery(this).scrollTop() - scrollTop);
                            var scrollingUp = jQuery(this).scrollTop() <= scrollTop;
                            var threshold = 8;
                            var scrollEnd = jQuery(document).height() - jQuery(window).height();

                            if (jQuery(this).scrollTop() < scrollEnd && scrollTop < scrollEnd) {
                                if (jQuery(this).scrollTop() < 99) {
                                    jQuery('.main-wrapper').removeClass('hidden-header');
                                    jQuery('.global-header').css({
                                        'box-shadow': ''
                                    });
                                } else if (jQuery(this).scrollTop() > 99) {
                                    jQuery('.global-header').css({
                                        'box-shadow': '0 .2em .1em rgba(0,0,0,.2)'
                                    });
                                }
                                if (speed > threshold) {
                                    jQuery('.main-wrapper').toggleClass('hidden-header', !scrollingUp);
                                    jQuery('.global-header').css({
                                        'box-shadow': '0 .2em .1em rgba(0,0,0,.2)'
                                    });
                                }
                            }
                            scrollTop = jQuery(this).scrollTop();
                        };

                    jQuery('.global-nav a').on({
                        'mouseover': delaySNOpen,
                        'focus': activateSN,
                        'click': preventDefault
                    });
                    jQuery('.global-header').on({
                        'mouseleave': closeSN
                    });
                    jQuery('.utility').on({
                        'mouseover': closeSN
                    });

                    jQuery(".sn-container a").click(function() {
                        closeSN();
                    });
                }
            });
        }
    };
};
